import { mockQuoteDetails } from '@domgen/dgx-fe-basket';
import { mockCustomerDetails } from '@domgen/dgx-fe-common';
import { RegistrationMessageResult } from '../../models/registration/registration-message-result.enum';
import { RegistrationResponse } from '../../models/registration/registration-response.interface';
import { mockRegistrationApplianceDetails } from '../registration-appliance-details/registration-appliance-details.mock';

export const mockEmptyRegistrationResponse: RegistrationResponse = {
  basketItemId: '',
  firstPayment: 0,
  item: mockRegistrationApplianceDetails,
  message: RegistrationMessageResult.Success,
  offerReference: '',
  person: mockCustomerDetails,
  quote: mockQuoteDetails,
  quoteId: '',
  tax: undefined,
};
